import { useContext, useEffect, useState } from 'react';
import axios from "axios";
import { useQueryParams } from "raviger";
import {
  Card,
} from 'react-bootstrap';
import { useCookies } from 'react-cookie';
import { AuthContext } from "./AccountsReducer";
import Header from '../components/Header';
import { logoutUser } from "./AccountsUtils";

const EmailVerification = ({ organization, id }) => {

    // Identify any query param data.
    const [queryParams] = useQueryParams();
    const {
        new_email = '',
    } = queryParams;

  const { state, dispatch } = useContext(AuthContext);
  const [, , removeCookie] = useCookies(['token']);

  const [success, setSuccess] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();
    const changeEmail = async () => {
      const values = {'id':id, 'organization':state.organization.id, 'new_email':new_email};
      axios.patch('/accounts/api/user/' + id + '/change_email/', values, {
        cancelToken: source.token,
      })
      .then(function () {
          setSuccess(true);
          setTimeout(() => {
            logoutUser({dispatch}, {removeCookie})
          }, 5000)
      })
      .catch(error => {
        setError(error.response ? error.response.data.error : 'Error')
        setSuccess(false)
      });
    };
    changeEmail();
    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, []);

  return (
    <>
    <span className="mt-3 ms-auto me-auto" style={{width:"80%", maxWidth:"80%"}}>
      <Header>
        Email Verification
      </Header>
      <div className="row mt-1">
        <div className="col-8 d-flex">
          <Card className="border rounded d-flex" style={{width:"100%"}}>
            <Card.Body>
              {success === true ? <span>
                {success ? <span>Your new email address has been successfully verified! You will be redirected to login with your new email address in 5 seconds.</span> : ""}
                {success === false ? <span>Email verification failed. Please contact a system administrator for help.</span> : ""}
              </span>
              : error ? <span>{error}</span> : ""}
            </Card.Body>
          </Card>
        </div>
      </div>
    </span>
    </>
  );
};

export default EmailVerification;